module.exports = __webpack_public_path__ + "static/media/header_logo_window_simulator.1d4e07c3.png";